import { Grid } from '@mui/material'
import { useSelector } from 'react-redux'

import { FC } from 'react'

import ResultsCard from '../../resultsCard'
import { RootState } from 'dataStore/state'
import { colors } from '../../../ThemeStyle'
import formatPrice from 'handlers/priceFormat'

/**
 * Три карточки статистики заказов. Все цифры приходят с бэкенда
 * (`GET /orders/dashboard-summary`), на фронте только отображение.
 */
const TotalBlock: FC = () => {
  const { statistic } = useSelector((state: RootState) => state.orders)

  const totalOrders = statistic?.totalCount ?? 0
  const ordersTodayYesterday = `${statistic?.todayCount ?? 0}/${
    statistic?.yesterdayCount ?? 0
  }`
  const price = Number(statistic?.totalSum ?? 0)

  return (
    <Grid container spacing={3} sx={{ mb: '25px' }}>
      <Grid item xs={12} sm={6} md={4}>
        <ResultsCard
          total={totalOrders}
          text={'Всего заказов'}
          color={colors.info}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <ResultsCard
          total={ordersTodayYesterday}
          text={'Заказов за сегодня/вчера'}
          color={colors.warning}
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <ResultsCard
          total={formatPrice(price)}
          text={'Сумма'}
          color={colors.success}
        />
      </Grid>
    </Grid>
  )
}

export default TotalBlock
